<template>
  <div class="apply-container">
    <el-dialog title="" :visible.sync="visible" width="800px" @closed="onClosed" top="60px">
      <ApplyCooperationForm ref="ApplyCooperationForm" @submit='submitForm' />
    </el-dialog>
  </div>
</template>

<script>
  import ApplyCooperationForm from "@/components/common/ApplyCooperationForm"
  import '@/styles/element-variables.scss'
  import {
    Dialog,Message 
  } from 'element-ui';
  export default {
    data() {
      return {
        visible: true
      };
    },
    methods: {
      //关闭
      onClosed() {
        this.$emit('input', false)
        this.$refs.ApplyCooperationForm.resetFields();
        this.$refs.ApplyCooperationForm.loading = false;
        this.$refs.ApplyCooperationForm.hasSubmit = false;
      },
	  submitForm(){
		 
		  // this.onClosed()
		  
	  },
    },
    components: {
      [Dialog.name]: Dialog,
      ApplyCooperationForm

    },
    props: {
      value: {
        default: false
      }
    },
    watch: {
      value: {
        handler(n, o) {
          this.visible = n
        },
        immediate: true
      }
    },
  };
</script>

<style scoped lang="scss">
  .apply-container {
    /deep/ .el-dialog__body {
      padding-top: 15px;
    }
  }

  .dialog-footer {
    margin-top: 0.5rem;

    /deep/ .el-button {
      width: 2.4rem;
      border-radius: 0;
      font-size: 0.2rem;
    }
  }
</style>